import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import ProductsPage from '@/pages/products/page';
import ProductDetailPage from '@/pages/products/detail/page';
import AboutPage from '@/pages/about/page';
import ContactPage from '@/pages/contact/page';
import DealerPage from '@/pages/dealer/page';
import DealerApplyPage from '@/pages/dealer/apply/page';
import DealerDashboardPage from '@/pages/dealer/dashboard/page';
import DealerOrdersPage from '@/pages/dealer/orders/page';
import DealerNewOrderPage from '@/pages/dealer/new-order/page';
import DealerProductsPage from '@/pages/dealer/dealer-products/page';
import DealerAccountPage from '@/pages/dealer/account/page';
import AdminLoginPage from '@/pages/admin/login/page';
import AdminDashboardPage from '@/pages/admin/dashboard/page';
import AdminProductsPage from '@/pages/admin/products/page';
import AdminOrdersPage from '@/pages/admin/orders/page';
import AdminDealersPage from '@/pages/admin/dealers/page';
import AdminSettingsPage from '@/pages/admin/settings/page';
import AdminAnalyticsPage from '@/pages/admin/analytics/page';
import AdminContentPage from '@/pages/admin/content/page';
import ComparePage from '@/pages/products/compare/page';
import AdminCampaignsPage from '@/pages/admin/campaigns/page';
import AdminContactSubmissionsPage from '@/pages/admin/contact-submissions/page';
import WarrantyClaimsPage from '@/pages/admin/warranty-claims/page';
import TechWikiPage from '@/pages/tech-wiki/page';
import WarrantyPage from '@/pages/legal/warranty/page';
import TermsPage from '@/pages/legal/terms/page';
import PrivacyPage from '@/pages/legal/privacy/page';
import FaqPage from '@/pages/faq/page';
import NotFound from '@/pages/NotFound';
import AuthCallbackPage from '@/pages/auth/callback/page';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  { path: '/products', element: <ProductsPage /> },
  { path: '/products/compare', element: <ComparePage /> },
  { path: '/products/:id', element: <ProductDetailPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/tech-wiki', element: <TechWikiPage /> },
  { path: '/warranty', element: <WarrantyPage /> },
  { path: '/terms', element: <TermsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/faq', element: <FaqPage /> },
  // Dealer public
  { path: '/dealer', element: <DealerPage /> },
  { path: '/dealer/apply', element: <DealerApplyPage /> },
  // Dealer portal (authenticated)
  { path: '/dealer/dashboard', element: <DealerDashboardPage /> },
  { path: '/dealer/orders', element: <DealerOrdersPage /> },
  { path: '/dealer/new-order', element: <DealerNewOrderPage /> },
  { path: '/dealer/products', element: <DealerProductsPage /> },
  { path: '/dealer/account', element: <DealerAccountPage /> },
  // Admin
  { path: '/admin/login', element: <AdminLoginPage /> },
  { path: '/admin', element: <AdminDashboardPage /> },
  { path: '/admin/analytics', element: <AdminAnalyticsPage /> },
  { path: '/admin/content', element: <AdminContentPage /> },
  { path: '/admin/products', element: <AdminProductsPage /> },
  { path: '/admin/campaigns', element: <AdminCampaignsPage /> },
  { path: '/admin/contact-submissions', element: <AdminContactSubmissionsPage /> },
  { path: '/admin/orders', element: <AdminOrdersPage /> },
  { path: '/admin/dealers', element: <AdminDealersPage /> },
  { path: '/admin/settings', element: <AdminSettingsPage /> },
  { path: '/admin/warranty-claims', element: <WarrantyClaimsPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
